import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function HeadingForLargePromo({ as, children }) {
  return (
    <Text
      as={as}
      uppercase
      fontSize={[42, 64, 82, 82]}
      color="white"
      lineHeight={1}
      textAlign="center"
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}

export default HeadingForLargePromo;

HeadingForLargePromo.defaultProps = {
  as: "h2",
};

HeadingForLargePromo.propTypes = {
  as: PropTypes.string,
};
